/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { LoadingDots } from '@ui/components';

export const DefaultLoadingDotsExample = () => <LoadingDots />;

export const SmallLoadingDotsExample = () => <LoadingDots size="sm" />;

export const LargeLoadingDotsExample = () => <LoadingDots size="lg" />;

export const WhiteLoadingDotsExample = () => (
    <div style={{ background: '#045778', borderRadius: 6, padding: 24 }}>
        <LoadingDots context="white" size="lg" />
    </div>
);

export const InlineLoadingDotsExample = () => (
    <span style={{ alignItems: 'center', display: 'inline-flex', gap: 8 }}>
        Loading results <LoadingDots size="sm" />
    </span>
);
